import { render, staticRenderFns } from "./BlockFour.vue?vue&type=template&id=d4bf2678&scoped=true&"
import script from "./BlockFour.vue?vue&type=script&lang=js&"
export * from "./BlockFour.vue?vue&type=script&lang=js&"
import style0 from "./BlockFour.vue?vue&type=style&index=0&id=d4bf2678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bf2678",
  null
  
)

export default component.exports